import { formatDistanceToNow } from 'date-fns';
import { pl, enUS } from 'date-fns/locale';
import { Box } from 'components/ui';
import { useLocale } from 'contexts/locale';

const LOCALES = {
  pl,
  en: enUS,
};

const RelativeTime = ({ date }) => {
  const { locale } = useLocale();

  if (!date) return null;

  const parsedDate = new Date(date);
  const formatted = formatDistanceToNow(parsedDate, {
    addSuffix: true,
    locale: LOCALES[locale] ?? enUS,
  });

  return (
    <Box component="span" sx={{ color: 'text.secondary', fontSize: 12 }}>
      {formatted}
    </Box>
  );
};

export default RelativeTime;
